var T = function (k, f) { var d = typeof window !== 'undefined' && window.VP_I18N; return d && typeof d[k] === 'string' ? d[k] : f; }; // vp-i18n T()
/* Native product photo upload: up to 10 photos per item, sent with the normal multipart add-to-cart form.
   2026-10-14 (user): accept most photos, including HEIC and files the browser cannot preview; up to 10 photos per item.
   - Photo 1 keeps the "Your photo" line property (order emails and the cart treat it as "photo received");
     photos 2-10 go out as "Photo 2" ... "Photo 10", each with a hidden "_Photo N filename".
   - Only empty files, non-image files, and photos over 12 MB that cannot be shrunk in the browser are turned away.
     Photos over 12 MB that the browser can open are re-saved as a JPG (longest side 4000 px) before upload.
   - Formats the browser cannot open (HEIC on most desktops, RAW, some TIFF) are still uploaded, just without a preview.
   - Browsers without DataTransfer (very old Safari) fall back to one photo per item.
   2026-10-17 (user approved, after a Spanish visitor on mobile tapped "Buy now" with 6 photos and nothing happened for ~50 s on a slow line):
   - Photos the browser can open are re-saved as a JPG with the longest side 2000 px (quality 0.85) when they are bigger than that
     or over 600 KB, so the sculptor still sees every face clearly and 6 phone photos go from ~15 MB to ~2 MB. Kept as-is if that is not smaller.
   - While the form uploads, the pressed button shows "Uploading your photos...", both buttons are disabled, a "keep this page open" line appears,
     and the gift / contact side tabs and the offer popup are hidden, so another tap cannot interrupt the purchase.
   2026-10-18 (user: "only the first uploaded photo can be viewed"): "View photo" and every thumbnail open an in-page viewer with
   previous / next (buttons, arrow keys, swipe), "2 / 5" and close (button, Esc, tap outside). Photos without a preview are skipped.
   Removing a photo also clears the "We kept the first 10" note. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.mount(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var MAX_BYTES = 12 * 1024 * 1024;
  var MAX_FILES = 10;
  var PHOTO_SIDE = 2000;
  var PHOTO_QUALITY = 0.85;
  var COMPRESS_OVER = 600 * 1024;
  var COPY = {
    missing: T('js.upload.missing', 'No photo yet? Add one here, or check out and email it to hello@voxelpals.com.'),
    pending: T('js.upload.pending', 'Checking your photos. Please wait before adding to cart.'),
    size: T('js.upload.too_big', 'This photo is over 12 MB. Choose a smaller version, or check out and email it to hello@voxelpals.com.'),
    empty: T('js.upload.empty', 'This file is empty. Please choose another photo, or check out and email it to hello@voxelpals.com.'),
    type: T('js.upload.type', 'This file is not a photo. Please choose an image, or check out and email it to hello@voxelpals.com.'),
    read: T('js.upload.read', 'This file could not be read. Choose it again, try another photo, or check out and email it to hello@voxelpals.com.'),
    max: T('js.upload.max', 'Up to 10 photos per item. We kept the first 10.'),
    othersKept: T('js.upload.others_kept', ' The other photos were added.'),
    noPreview: T('js.upload.no_preview', 'No preview for this format, but the photo will still be uploaded.'),
    addMore: T('js.upload.add_more', 'Add more photos'),
    count: T('js.upload.count', '{n} of 10 photos'),
    remove: T('js.upload.remove', 'Remove photo'),
    orLater: T('js.upload.or_later', ' Press the button again to continue.'),
    sending: T('js.upload.sending', 'Uploading your photos\u2026'),
    keepOpen: T('js.upload.keep_open', 'Please keep this page open. On a slow connection this can take a little while.'),
    prev: T('js.upload.view_prev', 'Previous photo'),
    next: T('js.upload.view_next', 'Next photo'),
    close: T('js.upload.view_close', 'Close')
  };
  /* 2026-09-27: the photo is optional at checkout. Upload it now, or order first and email it afterwards.
     Lines ordered without a photo carry a readable line property, so the order shows the photo is still to come.
     Do not use the "Your photo" key for this marker: the order confirmation email treats a non-empty "Your photo" as received. */
  var LATER_KEY = 'Photo';
  var LATER_VALUE = 'Will email after checkout';
  var IMAGE_EXT = /\.(jpe?g|jfif|png|webp|hei[cf]|avif|gif|bmp|tiff?|dng|cr2|nef|arw|raf|orf|rw2)$/i;
  var NOT_IMAGE_TYPE = /^(video|audio|text)\/|^application\/(pdf|zip|x-zip|msword|vnd\.)/i;
  var PLACEHOLDER = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" fill="#f3efe9"/><path d="M18 44l9-11 7 8 5-6 7 9z" fill="#c9bfb3"/><circle cx="40" cy="24" r="4" fill="#c9bfb3"/></svg>');

  function ascii(bytes, start, end) {
    return Array.prototype.map.call(bytes.slice(start, end), function (n) { return String.fromCharCode(n); }).join('');
  }
  function formatOf(bytes) {
    if (bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255) return 'jpeg';
    if ([137, 80, 78, 71, 13, 10, 26, 10].every(function (n, i) { return bytes[i] === n; })) return 'png';
    if (ascii(bytes, 0, 4) === 'RIFF' && ascii(bytes, 8, 12) === 'WEBP') return 'webp';
    if (ascii(bytes, 4, 8) === 'ftyp' && /heic|heix|hevc|hevx|heim|heis|hevm|hevs|mif1|msf1/.test(ascii(bytes, 8, 32))) return 'heic';
    if (ascii(bytes, 4, 8) === 'ftyp' && /avif|avis/.test(ascii(bytes, 8, 32))) return 'avif';
    if (ascii(bytes, 0, 3) === 'GIF') return 'gif';
    if (ascii(bytes, 0, 2) === 'BM') return 'bmp';
    if (ascii(bytes, 0, 4) === 'II*\u0000' || ascii(bytes, 0, 4) === 'MM\u0000*') return 'tiff';
    if (ascii(bytes, 0, 4) === '%PDF') return 'pdf';
    return null;
  }
  function readHeader(file, win) {
    var blob = file.slice(0, 32);
    if (blob.arrayBuffer) return blob.arrayBuffer();
    return new Promise(function (resolve, reject) {
      var reader = new win.FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = function () { reject(new Error('read')); };
      reader.readAsArrayBuffer(blob);
    });
  }
  /* Resolves with the loaded <img> (and its object URL) or null when the browser cannot open the format. Never rejects. */
  function decodePhoto(file, win) {
    return new Promise(function (resolve) {
      var image = new win.Image();
      var url = win.URL.createObjectURL(file);
      function finish(ok) {
        win.clearTimeout(timer);
        image.onload = image.onerror = null;
        if (ok && image.naturalWidth > 0 && image.naturalHeight > 0) resolve({ img: image, url: url });
        else { win.URL.revokeObjectURL(url); resolve(null); }
      }
      var timer = win.setTimeout(function () { finish(false); }, 15000);
      image.onload = function () { finish(true); };
      image.onerror = function () { finish(false); };
      image.src = url;
    });
  }
  function shrink(file, img, win) {
    return new Promise(function (resolve) {
      try {
        var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, PHOTO_SIDE / Math.max(w, h));
        var c = win.document.createElement('canvas');
        c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        var g = c.getContext('2d');
        g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); // transparent PNGs would otherwise turn black in a JPG
        g.drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (blob) {
          if (!blob || blob.size > MAX_BYTES) { resolve(null); return; }
          var name = String(file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
          try { resolve(new win.File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified || Date.now() })); }
          catch (e) { resolve(null); }
        }, 'image/jpeg', PHOTO_QUALITY);
      } catch (e) { resolve(null); }
    });
  }
  /* Checks one file. Resolves { ok, error, file, url } — url is a preview object URL or null (no preview for this format). */
  async function validate(file, env) {
    env = env || {};
    if (!file) return { ok: false, error: 'missing' };
    if (!file.size) return { ok: false, error: 'empty' };
    var bytes;
    try { bytes = new Uint8Array(await (env.readHeader || readHeader)(file, env.win)); }
    catch (error) { return { ok: false, error: 'read' }; }
    var format = formatOf(bytes);
    var typed = /^image\//i.test(file.type || '') || IMAGE_EXT.test(file.name || '');
    if (format === 'pdf' || (!format && !typed) || (!format && NOT_IMAGE_TYPE.test(file.type || ''))) return { ok: false, error: 'type' };
    var shown = env.win && env.win.Image ? await (env.decode || decodePhoto)(file, env.win) : null;
    var big = shown && (file.size > COMPRESS_OVER || Math.max(shown.img.naturalWidth, shown.img.naturalHeight) > PHOTO_SIDE);
    if (big && env.canShrink) {
      var smaller = await shrink(file, shown.img, env.win);
      if (smaller && smaller.size < file.size) file = smaller;
    }
    if (file.size > MAX_BYTES) { if (shown) env.win.URL.revokeObjectURL(shown.url); return { ok: false, error: 'size' }; }
    return { ok: true, format: format || 'image', file: file, url: shown ? shown.url : null };
  }

  function mount(win, options) {
    options = options || {};
    var doc = win.document;
    var box = doc.querySelector('[data-cfx-upload]');
    if (!box || box.getAttribute('data-photo-validation') === 'ready') return;
    var input = box.querySelector('.cfx-upload__input');
    var form = doc.getElementById('vpCartForm');
    var zone = box.querySelector('[data-cfx-zone]');
    var preview = box.querySelector('[data-cfx-preview]');
    var img = box.querySelector('[data-cfx-img]');
    var note = box.querySelector('[data-cfx-required]');
    if (!input || !form || !zone || !preview || !img || !note) return;
    box.setAttribute('data-photo-validation', 'ready');
    var name = box.querySelector('[data-cfx-name]');
    var originalName = box.querySelector('[data-cfx-filename]');
    var size = box.querySelector('[data-cfx-size]');
    var views = [box.querySelector('[data-cfx-view]'), box.querySelector('[data-cfx-view2]')];
    var change = box.querySelector('[data-cfx-change]');
    var multi = false;
    try { multi = typeof win.DataTransfer === 'function' && !!new win.DataTransfer().items; } catch (e) { multi = false; }
    // Older cached HTML may still carry the required attribute: switch it off so the browser does not block checkout.
    input.required = false;
    input.setAttribute('accept', 'image/*,.heic,.heif,.jpg,.jpeg,.png,.webp,.avif,.gif,.bmp,.tif,.tiff,.dng');
    if (multi) input.multiple = true;
    var later = doc.createElement('input');
    later.type = 'hidden';
    later.name = 'properties[' + LATER_KEY + ']';
    later.value = LATER_VALUE;
    later.disabled = true;
    later.setAttribute('data-cfx-later', '');
    box.appendChild(later);
    if (!doc.getElementById('vpPhotosCss')) {
      var st = doc.createElement('style');
      st.id = 'vpPhotosCss';
      st.textContent = '[data-cfx-preview]{flex-wrap:wrap}.vp-photos{flex-basis:100%;width:100%;margin-top:10px}' +
        '.vp-photos[hidden]{display:none!important}' +
        '.vp-photos__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(64px,1fr));gap:8px}' +
        '.vp-photos__item{position:relative;aspect-ratio:1;border-radius:9px;overflow:hidden;border:1px solid rgba(23,19,30,.14);background:#f3efe9}' +
        '.vp-photos .vp-photos__item img{width:100%;height:100%;max-width:none;object-fit:cover;display:block;border-radius:0}' +
        '.vp-photos__item span{position:absolute;left:4px;bottom:3px;max-width:calc(100% - 8px);font:600 10px/1.2 system-ui,sans-serif;color:#17131e;background:rgba(255,255,255,.86);border-radius:4px;padding:1px 4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
        '.vp-photos__rm{position:absolute;top:3px;right:3px;width:24px;height:24px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;background:rgba(23,19,30,.78);color:#fff;font:700 15px/1 system-ui,sans-serif;cursor:pointer}' +
        '.vp-photos__rm:focus-visible{outline:2px solid #e50044;outline-offset:1px}' +
        '.vp-photos__add{margin-top:10px;display:inline-flex;align-items:center;gap:6px;min-height:40px;padding:8px 14px;border:1.5px dashed rgba(23,19,30,.32);border-radius:999px;background:#fff;color:#17131e;font:inherit;font-size:.82rem;font-weight:700;cursor:pointer}' +
        '.vp-photos__add:hover{border-color:#e50044}' +
        '.vp-photos__add[hidden]{display:none!important}' +
        '.vp-photos__note{margin:8px 0 0;font-size:.74rem;line-height:1.4;color:rgba(23,19,30,.62)}' +
        '.vp-photos__note[hidden]{display:none!important}' +
        '.vp-uploading .vp-offer-tab,.vp-uploading .vp-contact-tab,.vp-uploading #vpPrelaunch{display:none!important}' +
        '.vp-upbusy__spin{display:inline-block;width:1em;height:1em;margin-right:.5em;vertical-align:-.15em;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:vpUpSpin .8s linear infinite}' +
        '@keyframes vpUpSpin{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.vp-upbusy__spin{animation:none}}' +
        'button[aria-busy=true]{cursor:progress}' +
        '.vp-upbusy__note{margin:10px 0 0;font-size:.82rem;line-height:1.45;color:rgba(23,19,30,.72);text-align:center}' +
        '.vp-photos__open{display:block;width:100%;height:100%;padding:0;border:0;background:none;cursor:zoom-in}' +
        '.vp-photos__open:focus-visible{outline:2px solid #e50044;outline-offset:-2px}' +
        '.vp-lb{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:64px 12px 72px;background:rgba(12,9,16,.94);touch-action:pan-y}' +
        '.vp-lb[hidden]{display:none!important}' +
        '.vp-lb__fig{margin:0;display:flex;flex-direction:column;align-items:center;max-width:100%;max-height:100%}' +
        '.vp-lb__img{display:block;max-width:min(94vw,960px);max-height:calc(100vh - 150px);max-height:calc(100dvh - 150px);width:auto;height:auto;object-fit:contain;border-radius:10px;background:#fff;user-select:none;-webkit-user-drag:none}' +
        '.vp-lb__cap{margin-top:12px;color:#fff;font:600 15px/1.2 system-ui,sans-serif;letter-spacing:.04em}' +
        '.vp-lb button{position:absolute;display:flex;align-items:center;justify-content:center;width:46px;height:46px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#17131e;font:700 26px/1 system-ui,sans-serif;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.25)}' +
        '.vp-lb button:focus-visible{outline:3px solid #e50044;outline-offset:2px}' +
        '.vp-lb button[hidden]{display:none!important}' +
        '.vp-lb__close{top:max(12px,env(safe-area-inset-top));right:12px}' +
        '.vp-lb__prev{left:10px;top:50%;transform:translateY(-50%)}.vp-lb__next{right:10px;top:50%;transform:translateY(-50%)}' +
        '@media (max-width:640px){.vp-lb__prev,.vp-lb__next{top:auto;bottom:max(14px,env(safe-area-inset-bottom));transform:none}.vp-lb__prev{left:calc(50% - 64px)}.vp-lb__next{right:calc(50% - 64px)}}' +
        'html.vp-lb-open{overflow:hidden}';
      doc.head.appendChild(st);
    }
    var strip = doc.createElement('div');
    strip.className = 'vp-photos';
    strip.hidden = true;
    var grid = doc.createElement('div');
    grid.className = 'vp-photos__grid';
    grid.setAttribute('role', 'list');
    var addBtn = doc.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'vp-photos__add';
    addBtn.innerHTML = '<span aria-hidden="true">+</span> ';
    addBtn.appendChild(doc.createTextNode(COPY.addMore));
    var hint = doc.createElement('p');
    hint.className = 'vp-photos__note';
    hint.hidden = true;
    hint.textContent = COPY.noPreview;
    strip.appendChild(grid);
    if (multi) strip.appendChild(addBtn);
    strip.appendChild(hint);
    preview.appendChild(strip);
    var extras = doc.createElement('div');
    extras.hidden = true;
    extras.setAttribute('data-vp-photo-extras', '');
    box.appendChild(extras);

    var entries = [], busy = 0, sequence = 0, appendNext = false, errorCode = null, failed = null;
    // The "No photo yet?" hint (id ending in PhotoLater) is hidden by CSS while a photo preview is showing:
    // take it out of the input's accessible description then too, and put it back when the photo is cleared.
    var describedBy = input.getAttribute('aria-describedby') || '';
    function describeLater(on) {
      if (!/PhotoLater(\s|$)/.test(describedBy)) return;
      input.setAttribute('aria-describedby', describedBy.split(/\s+/).filter(function (id) { return id && (on || !/PhotoLater$/.test(id)); }).join(' '));
    }
    function fmtSize(bytes) {
      return bytes >= 1048576 ? (bytes / 1048576).toFixed(1) + T('js.upload.unit_mb', ' MB') : Math.max(1, Math.round(bytes / 1024)) + T('js.upload.unit_kb', ' KB');
    }
    function message(code, focus, extra) {
      var invalid = !!code && code !== 'pending' && code !== 'max';
      errorCode = code;
      note.textContent = code ? (COPY[code] || '') + (extra || '') : '';
      note.hidden = !code;
      note.setAttribute('role', invalid ? 'alert' : 'status');
      box.classList.toggle('is-invalid', invalid);
      input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      if (focus) {
        zone.focus({ preventScroll: true });
        zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    function fileList(files) {
      var dt = new win.DataTransfer();
      files.forEach(function (f) { dt.items.add(f); });
      return dt.files;
    }
    /* Put photo 1 in the original "Your photo" field and photos 2-10 in their own file fields, so the normal form submit uploads them all. */
    function distribute() {
      if (originalName) originalName.value = entries.length ? entries[0].name : '';
      if (!multi) return;
      try { input.files = fileList(entries.length ? [entries[0].file] : []); } catch (e) {}
      while (extras.firstChild) extras.removeChild(extras.firstChild);
      for (var i = 1; i < entries.length; i++) {
        var f = doc.createElement('input');
        f.type = 'file';
        f.name = 'properties[Photo ' + (i + 1) + ']';
        f.tabIndex = -1;
        try { f.files = fileList([entries[i].file]); } catch (e) { continue; }
        var n = doc.createElement('input');
        n.type = 'hidden';
        n.name = 'properties[_Photo ' + (i + 1) + ' filename]';
        n.value = entries[i].name;
        extras.appendChild(f);
        extras.appendChild(n);
      }
    }
    function render() {
      var first = entries[0];
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      if (!first) {
        img.removeAttribute('src');
        views.forEach(function (link) { if (link) link.removeAttribute('href'); });
        preview.hidden = true;
        zone.hidden = false;
        strip.hidden = true;
        describeLater(true);
        return;
      }
      img.src = first.url || PLACEHOLDER;
      views.forEach(function (link) { if (link) { if (first.url) link.href = first.url; else link.removeAttribute('href'); } });
      var total = entries.reduce(function (s, e) { return s + e.file.size; }, 0);
      if (name) name.textContent = entries.length > 1 ? COPY.count.replace('{n}', entries.length) : first.name;
      if (size) size.textContent = fmtSize(total);
      grid.hidden = entries.length < 2;
      entries.forEach(function (e, i) {
        var item = doc.createElement('div');
        item.className = 'vp-photos__item';
        item.setAttribute('role', 'listitem');
        var im = doc.createElement('img');
        im.alt = e.name;
        im.src = e.url || PLACEHOLDER;
        if (e.url) {
          var open = doc.createElement('button');
          open.type = 'button';
          open.className = 'vp-photos__open';
          open.setAttribute('aria-label', viewLabel() + ' ' + (i + 1) + ': ' + e.name);
          open.appendChild(im);
          open.addEventListener('click', function () { viewerOpen(e); });
          item.appendChild(open);
        } else {
          item.appendChild(im);
        }
        if (!e.url) { var cap = doc.createElement('span'); cap.textContent = e.name; item.appendChild(cap); }
        var rm = doc.createElement('button');
        rm.type = 'button';
        rm.className = 'vp-photos__rm';
        rm.setAttribute('aria-label', COPY.remove + ': ' + e.name);
        rm.textContent = '×';
        rm.addEventListener('click', function () { removeAt(i); });
        item.appendChild(rm);
        grid.appendChild(item);
      });
      addBtn.hidden = !multi || entries.length >= MAX_FILES;
      hint.hidden = entries.every(function (e) { return !!e.url; });
      strip.hidden = false;
      zone.hidden = true;
      preview.hidden = false;
      describeLater(false);
    }
    /* 2026-10-18: in-page photo viewer (all photos, not just the first). */
    var viewer = null, viewerImg = null, viewerCap = null, viewerPrev = null, viewerNext = null, viewerList = [], viewerAt = 0, viewerBack = null, touchX = null;
    function viewLabel() {
      var v = views[1] || views[0];
      var t = v ? (v.textContent || v.getAttribute('aria-label') || v.getAttribute('title') || '').trim() : '';
      return t || 'View photo';
    }
    function viewerShow(k) {
      var n = viewerList.length;
      if (!n) return;
      viewerAt = (k + n) % n;
      var e = viewerList[viewerAt];
      viewerImg.src = e.url;
      viewerImg.alt = e.name;
      viewerCap.textContent = n > 1 ? (viewerAt + 1) + ' / ' + n : '';
      viewerPrev.hidden = viewerNext.hidden = n < 2;
    }
    function viewerKey(event) {
      if (!viewer || viewer.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); viewerClose(); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); viewerShow(viewerAt - 1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); viewerShow(viewerAt + 1); }
      else if (event.key === 'Tab') {
        // keep focus inside the viewer
        var f = [viewerClose_btn, viewerPrev, viewerNext].filter(function (b) { return !b.hidden; });
        var at = f.indexOf(doc.activeElement);
        event.preventDefault();
        f[(at + (event.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    }
    var viewerClose_btn = null;
    function viewerBuild() {
      if (viewer) return;
      viewer = doc.createElement('div');
      viewer.className = 'vp-lb';
      viewer.hidden = true;
      viewer.setAttribute('role', 'dialog');
      viewer.setAttribute('aria-modal', 'true');
      viewer.setAttribute('aria-label', viewLabel());
      function btn(cls, text, label) {
        var b = doc.createElement('button');
        b.type = 'button';
        b.className = cls;
        b.textContent = text;
        b.setAttribute('aria-label', label);
        viewer.appendChild(b);
        return b;
      }
      viewerClose_btn = btn('vp-lb__close', '\u00d7', COPY.close);
      viewerPrev = btn('vp-lb__prev', '\u2039', COPY.prev);
      viewerNext = btn('vp-lb__next', '\u203a', COPY.next);
      var fig = doc.createElement('figure');
      fig.className = 'vp-lb__fig';
      viewerImg = doc.createElement('img');
      viewerImg.className = 'vp-lb__img';
      viewerImg.draggable = false;
      viewerCap = doc.createElement('figcaption');
      viewerCap.className = 'vp-lb__cap';
      viewerCap.setAttribute('aria-live', 'polite');
      fig.appendChild(viewerImg);
      fig.appendChild(viewerCap);
      viewer.appendChild(fig);
      viewerClose_btn.addEventListener('click', viewerClose);
      viewerPrev.addEventListener('click', function () { viewerShow(viewerAt - 1); });
      viewerNext.addEventListener('click', function () { viewerShow(viewerAt + 1); });
      viewer.addEventListener('click', function (event) { if (event.target === viewer || event.target === fig) viewerClose(); });
      viewer.addEventListener('touchstart', function (event) { touchX = event.touches.length === 1 ? event.touches[0].clientX : null; }, { passive: true });
      viewer.addEventListener('touchend', function (event) {
        if (touchX === null || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 40 && viewerList.length > 1) viewerShow(viewerAt + (dx < 0 ? 1 : -1));
      }, { passive: true });
      doc.addEventListener('keydown', viewerKey);
      doc.body.appendChild(viewer);
    }
    function viewerOpen(start) {
      viewerList = entries.filter(function (e) { return !!e.url; });
      if (!viewerList.length) return false;
      viewerBuild();
      viewerBack = doc.activeElement;
      viewerShow(Math.max(0, viewerList.indexOf(start)));
      viewer.hidden = false;
      doc.documentElement.classList.add('vp-lb-open');
      viewerClose_btn.focus({ preventScroll: true });
      return true;
    }
    function viewerClose() {
      if (!viewer || viewer.hidden) return;
      viewer.hidden = true;
      viewerImg.removeAttribute('src');
      doc.documentElement.classList.remove('vp-lb-open');
      if (viewerBack && viewerBack.focus) viewerBack.focus({ preventScroll: true });
    }
    views.forEach(function (link) {
      if (link) link.addEventListener('click', function (event) { if (viewerOpen(entries[0])) event.preventDefault(); });
    });
    function removeAt(i) {
      var gone = entries.splice(i, 1)[0];
      if (gone && gone.url) win.URL.revokeObjectURL(gone.url);
      distribute();
      render();
      if (!entries.length) { input.value = ''; message(null); }
      else if (errorCode === 'max') message(null);
    }
    function clearAll() {
      viewerClose();
      entries.forEach(function (e) { if (e.url) win.URL.revokeObjectURL(e.url); });
      entries = [];
      distribute();
      render();
    }
    async function changed() {
      var turn = ++sequence, picked = Array.prototype.slice.call(input.files || []), adding = appendNext;
      appendNext = false;
      if (!picked.length) {
        // Picker cancelled: keep what was already chosen.
        distribute();
        if (!entries.length) message(null);
        return;
      }
      if (!adding) clearAll();
      failed = null;
      busy++;
      message('pending');
      var room = MAX_FILES - entries.length, firstError = null, dropped = 0, added = 0;
      for (var i = 0; i < picked.length; i++) {
        if (turn !== sequence) break;
        if (added >= room) { dropped++; continue; }
        var r = await validate(picked[i], { win: win, readHeader: options.readHeader, decode: options.decode, canShrink: multi });
        if (turn !== sequence) { if (r.url) win.URL.revokeObjectURL(r.url); break; }
        if (!r.ok) { firstError = firstError || r.error; continue; }
        entries.push({ file: r.file, url: r.url, name: r.file.name || picked[i].name || 'photo' });
        added++;
      }
      busy--;
      if (turn !== sequence) return;
      distribute();
      render();
      if (!multi && !entries.length) input.value = '';
      if (firstError && !entries.length) { failed = firstError; message(firstError); return; }
      if (firstError) { message(firstError, false, COPY.othersKept); return; }
      if (dropped) { message('max'); return; }
      message(null);
    }
    function showProblem() { message(errorCode || 'missing', true); }
    input.addEventListener('change', changed);
    input.addEventListener('invalid', function (event) { event.preventDefault(); showProblem(); });
    form.addEventListener('submit', function (event) {
      // Photos are still being checked: wait for them.
      if (busy) { event.preventDefault(); message('pending', true); return; }
      // The photo they just chose was rejected: explain once, the next tap continues without a photo.
      if (!entries.length && failed) { var code = failed; failed = null; event.preventDefault(); message(code, true, COPY.orLater); return; }
      // No usable photo: mark the line so the order shows the photo is still to come (sent by email after checkout).
      later.disabled = entries.length > 0;
      // Leave the empty file field out of this submission; switch it back on once the form data has been built.
      if (!entries.length) { input.disabled = true; (win.setTimeout || setTimeout)(function () { input.disabled = false; }, 0); }
    }, true);
    /* 2026-10-17: show that the purchase is on its way while the photos upload (a native submit gives no feedback at all). */
    var saved = null, busyNote = null, busyTimer = null;
    function esc(t) { return String(t).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
    function startBusy(submitter) {
      if (saved || !entries.length) return;
      saved = [];
      doc.documentElement.classList.add('vp-uploading');
      var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type=submit],input[type=submit]'))
        .concat(Array.prototype.slice.call(doc.querySelectorAll('[form="vpCartForm"][type=submit],[data-sbar-add],[data-sbar-buy]')));
      var label = submitter && buttons.indexOf(submitter) > -1 ? submitter : (form.querySelector('button[name="return_to"]') || buttons[0]);
      var buying = !!(label && label.name === 'return_to');
      buttons.forEach(function (b) {
        if (saved.some(function (x) { return x.el === b; })) return;
        var showText = b === label || (buying && b.hasAttribute('data-sbar-buy')) || (!buying && b.hasAttribute('data-sbar-add'));
        saved.push({ el: b, html: showText ? b.innerHTML : null, disabled: b.disabled });
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
        if (showText) b.innerHTML = '<span class="vp-upbusy__spin" aria-hidden="true"></span>' + esc(COPY.sending);
      });
      busyNote = doc.createElement('p');
      busyNote.className = 'vp-upbusy__note';
      busyNote.setAttribute('role', 'status');
      busyNote.textContent = COPY.keepOpen;
      if (label && label.parentNode && form.contains(label)) label.parentNode.insertBefore(busyNote, label.nextSibling);
      // Safety net: if the browser never leaves the page (upload stopped by the visitor), give the buttons back after 5 minutes.
      busyTimer = win.setTimeout(stopBusy, 300000);
    }
    function stopBusy() {
      if (!saved) return;
      win.clearTimeout(busyTimer);
      saved.forEach(function (x) {
        x.el.disabled = x.disabled;
        x.el.removeAttribute('aria-busy');
        if (x.html !== null) x.el.innerHTML = x.html;
      });
      saved = null;
      if (busyNote && busyNote.parentNode) busyNote.parentNode.removeChild(busyNote);
      busyNote = null;
      doc.documentElement.classList.remove('vp-uploading');
    }
    // Runs after every other submit handler: only a submission nobody cancelled goes busy. The form data is already built by then,
    // so disabling the buttons does not change what is sent (the pressed "Buy now" still carries return_to=/checkout).
    form.addEventListener('submit', function (event) {
      var submitter = event.submitter || null;
      (win.setTimeout || setTimeout)(function () { if (!event.defaultPrevented) startBusy(submitter); }, 0);
    });
    // Coming back with the browser's Back button restores the page from cache: put the buttons back.
    win.addEventListener('pageshow', function (event) { if (event.persisted) stopBusy(); });
    zone.tabIndex = 0;
    zone.setAttribute('role', 'button');
    zone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); input.click(); }
    });
    if (change) change.addEventListener('click', function () { appendNext = false; input.click(); });
    addBtn.addEventListener('click', function () { appendNext = true; input.click(); });
    form.addEventListener('reset', function () {
      ++sequence; failed = null; busy = 0; clearAll(); message(null); later.disabled = true;
    });
    if (input.files && input.files.length) changed();
  }
  return { mount: mount, validate: validate, formatOf: formatOf, MAX_BYTES: MAX_BYTES, MAX_FILES: MAX_FILES, PHOTO_SIDE: PHOTO_SIDE, COPY: COPY };
});
